var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.currentTime)?_c('mdc-button',{staticClass:"w-full",attrs:{"ripple":""},domProps:{"textContent":_vm._s((_vm.buttonTime + "*"))},nativeOn:{"click":function($event){return _vm.showDialog.apply(null, arguments)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }